import { Calendar as AntdCalendar, CalendarProps } from 'antd';

import styled from 'styled-components';

import { IconButton } from '@shared/ui';
import { ArrowLeft, ArrowRight } from '@phosphor-icons/react';
import { Stack } from '@mui/material';
import { ClassModel, IEventModel } from '@shared/types';

import './Calendar.css';
import { useCallback, useState } from 'react';
import { calendarInjection } from './calendarInjection';
import dayjs from 'dayjs';

calendarInjection();

const StyledCalendarComponent = styled.div`
  border-radius: 1em;
  background-color: #ffffff;
  padding: 1em;
  display: flex;
  flex-direction: column;
  gap: 2em;
`;

const StyledCalendarHeader = styled.div`
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 0.5em;
`;

const StyledCalendarMonthYear = styled.div`
  text-align: center;
  width: 8.5em;
`;

const MonthNavigateButton = styled(IconButton)`
  border: 1px solid #d5d9e2;
`;

interface IProps {
  data: IEventModel[];
  panelChangeHandler: (date: dayjs.Dayjs) => void;
}

const StyledCell = styled(Stack)``;

const StyledCellItem = styled(Stack)`
  display: flex;
  background-color: #e8f5e9;
  color: #388e3c;
`;

export const Calendar = ({ data, panelChangeHandler }: IProps) => {
  const [currentDate, setCurrentDate] = useState<dayjs.Dayjs>(dayjs());

  const updateMonthHandler = useCallback((modifier: number) => {
    setCurrentDate(prevDate => {
      return prevDate.add(modifier, 'month');
    });
  }, []);

  const headerRenderHandler = useCallback(() => {
    const year = currentDate.year();
    const month = currentDate.month();
    const date = new Date(year, month).toLocaleString('default', { month: 'long' });
    const displayMonthYear = `${date} ${year}`;

    return (
      <StyledCalendarHeader>
        <MonthNavigateButton onClick={() => updateMonthHandler(-1)}>
          <ArrowLeft />
        </MonthNavigateButton>
        <StyledCalendarMonthYear>{displayMonthYear}</StyledCalendarMonthYear>
        <MonthNavigateButton onClick={() => updateMonthHandler(1)}>
          <ArrowRight />
        </MonthNavigateButton>
      </StyledCalendarHeader>
    );
  }, [updateMonthHandler, currentDate]);

  return (
    <StyledCalendarComponent>
      <AntdCalendar
        value={currentDate}
        onChange={date => setCurrentDate(date)}
        cellRender={(date, info) => {
          const formattedDate = date.format('YYYY-MM-DD');
          const eventsOnDate = data.flatMap(item => item.lessons).filter(event => event.lessonDate === formattedDate);

          return (
            <StyledCell gap={0.5} padding={0.5}>
              {eventsOnDate.map(value => {
                return (
                  <StyledCellItem gap={0.5} borderRadius={1} padding={'0.25rem 1rem'} key={value.id}>
                    {value.class.name}
                  </StyledCellItem>
                );
              })}
            </StyledCell>
          );
        }}
        headerRender={headerRenderHandler}
        onPanelChange={(date, mode) => {
          panelChangeHandler(date);
        }}
      />
    </StyledCalendarComponent>
  );
};
